import { createSlice } from "@reduxjs/toolkit";

export const operatorsSlice = createSlice({
  name: "operators",
  initialState: {
    operators: [],
    selectedOperators: [],
    invitedOperators: [],
  },
  reducers: {
    setOperators: (state, action) => {
      state.operators = action.payload;
    },
    clearOperators: (state) => {
      state.operators = [];
    },
    setSelectedOperators: (state, action) => {
      state.selectedOperators = action.payload;
    },
    addSelectedOperator: (state, action) => {
      state.selectedOperators = [...state.selectedOperators, action.payload];
    },
    removeSelectedOperator: (state, action) => {
      state.selectedOperators = state.selectedOperators.filter(
        (operator) => operator.id !== action.payload
      );
    },
    clearSelectedOperators: (state) => {
      state.selectedOperators = [];
    },
    setInvitedOperators: (state, action) => {
      state.invitedOperators = action.payload;
    },
    clearInvitedOperators: (state) => {
      state.invitedOperators = [];
    },
    addInvitedOperator: (state, action) => {
      state.invitedOperators = [...state.invitedOperators, action.payload];
    },
  },
});

export const {
  setOperators,
  clearOperators,
  setSelectedOperators,
  addSelectedOperator,
  removeSelectedOperator,
  clearSelectedOperators,
  setInvitedOperators,
  clearInvitedOperators,
  addInvitedOperator,
} = operatorsSlice.actions;

export default operatorsSlice.reducer;
